// 행사 연도 API — 2026 프론트 화면에서는 api_admin.php 조회 API만 사용
import { callApi } from "./callApi";

export const fetchEventYears = async () => {
  const res = await callApi({
    endpoint: "/event_year_list",
    body: {},
    target: "admin",
  });
  return {
    ok: res?.code === 1000,
    data: Array.isArray(res?.data) ? res.data : [],
    raw: res,
  };
};
